import { forwardRef, useRef, useImperativeHandle } from "react";
import { useState } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";

const CustomSearch = forwardRef(function CustomSearch(
  {
    onSearch,
    onChange,
    otherRequiredProps,
    clearAfterChange = true,
    filterByDisabled = true,
  },
  ref
) {
  const [typeAheadLoading, setTypeAheadLoading] = useState(false);
  const [typeAheadSelection, setTypeAheadSelection] = useState([]);
  const [typeAheadOptions, setTypeAheadOptions] = useState([]);
  const internalRef = useRef();
  useImperativeHandle(
    ref,
    () => {
      return {
        // ...internalRef.current,
        selected() {
          //console.log(typeAheadSelection);
          return [...typeAheadSelection];
        },
        innerText() {
          return internalRef.current.getInput().value;
        },
        clear() {
          internalRef.current.clear();
        },
        // getInput(),
      };
    },
    [typeAheadSelection]
  );
  const handleSearch = async (query) => {
    setTypeAheadLoading(true);
    const searchResponse =
      onSearch instanceof Function ? await onSearch(query) : [];
    setTypeAheadOptions(searchResponse);
    setTypeAheadLoading(false);
  };
  const handleChange = (selected) => {
    if (onChange instanceof Function) {
      onChange(selected);
    } else {
      clearAfterChange = false;
    }
    if (clearAfterChange) {
      internalRef.current.clear();
      setTypeAheadSelection([]);
    } else {
      //console.log(internalRef.current.selected);
      setTypeAheadSelection(selected);
    }
  };
  return (
    <AsyncTypeahead
      isLoading={typeAheadLoading}
      selected={typeAheadSelection}
      onChange={handleChange}
      onSearch={handleSearch}
      options={typeAheadOptions}
      filterBy={() => filterByDisabled}
      minLength={2}
      delay={1000}
      {...otherRequiredProps}
      ref={internalRef}
    />
  );
});
export default CustomSearch;
